import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { X, Download, Smartphone } from "lucide-react";

const STORAGE_KEY = "simadin_install_dismissed_until";

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);
  const [supported, setSupported] = useState(true);

  useEffect(() => {
// Jangan tampilkan popup jika aplikasi sudah terpasang
const isStandalone =
  window.matchMedia("(display-mode: standalone)").matches ||
  window.navigator.standalone === true;

if (isStandalone) {
  return;
}
    // Jangan tampil jika sudah dipilih "Nanti Saja"
    const dismissedUntil = localStorage.getItem(STORAGE_KEY);
    if (dismissedUntil && Date.now() < Number(dismissedUntil)) {
      return;
    }

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);

      setTimeout(() => {
        setSupported(true);
        setShow(true);
      }, 3000);
    };

    window.addEventListener(
      "beforeinstallprompt",
      handleBeforeInstallPrompt
    );

    // Browser tidak mendukung beforeinstallprompt
    setTimeout(() => {
      if (!deferredPrompt) {
        setSupported(false);
        setShow(true);
      }
    }, 3000);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  const close = () => {
    setShow(false);
  };

  const later = () => {
    const sevenDays = Date.now() + 7 * 24 * 60 * 60 * 1000;
    localStorage.setItem(STORAGE_KEY, sevenDays.toString());
    setShow(false);
  };

  const install = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();

    await deferredPrompt.userChoice;

    setDeferredPrompt(null);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm px-4">
      <div className="relative w-full max-w-md rounded-3xl border border-white/10 ... animate-in slide-in-from-bottom-8 fade-in duration-500">

        {/* Tombol X */}
        <button
          onClick={close}
          className="absolute right-4 top-4 text-white/80 hover:text-white transition"
        >
          <X className="h-5 w-5" />
        </button>

        <div className="p-8 text-center">

          <img
            src="/assets/logo.png"
            alt="SiMadin"
            className="mx-auto mb-5 h-20 w-20 rounded-2xl shadow-lg"
          />

          <h2 className="text-2xl font-bold text-white">
            Install SiMadin
          </h2>

          <p className="mt-3 text-sm text-white/80 leading-relaxed">
            Install aplikasi SiMadin agar lebih cepat diakses seperti aplikasi
            Android dan dapat digunakan dengan pengalaman yang lebih nyaman.
          </p>

          {supported ? (
            <>
              <Button
                onClick={install}
                className="w-full h-14 rounded-2xl bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-lg shadow-xl transition-all duration-300 hover:scale-[1.02]"
              >
                <Download className="mr-2 h-5 w-5" />
                Install Sekarang
              </Button>

              <Button
                variant="secondary"
                onClick={later}
                className="mt-3 w-full rounded-xl h-11"
              >
                Nanti Saja
              </Button>
<p className="mt-4 text-center text-xs text-white/70">
  Tidak memerlukan Play Store dan dapat diperbarui secara otomatis.
</p>
            </>
          ) : (
            <div className="mt-6 rounded-2xl bg-white/10 p-4 text-left text-white/90 text-sm">
              <div className="flex items-center gap-2 mb-2">
                <Smartphone className="h-5 w-5" />
                <span className="font-semibold">
                  Browser belum mendukung instal otomatis
                </span>
              </div>

              <p>
                Tambahkan aplikasi ke layar utama secara manual:
              </p>

              <ol className="list-decimal pl-5 mt-2 space-y-1">
                <li>Buka menu browser (⋮ atau Share).</li>
                <li>Pilih <b>Tambahkan ke Layar Utama</b>.</li>
                <li>Tekan <b>Install</b> atau <b>Tambah</b>.</li>
              </ol>

              <Button
                variant="secondary"
                onClick={later}
                className="mt-5 w-full rounded-xl"
              >
                Nanti Saja
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
